import type { Invoice } from '@snootsvet/shared'
import { titleCase } from '@snootsvet/shared'

import { Badge, type BadgeVariants } from '@/frontend/components/ui/badge'

export function InvoiceStatusBadge({
  invoice,
  size = 'sm',
}: {
  invoice: Invoice
  size: BadgeVariants['size']
}) {
  if (invoice.overdue) {
    return (
      <Badge variant="destructive" size={size}>
        Overdue
      </Badge>
    )
  }
  if (invoice.status === 'open' && invoice.amountDue > 0) {
    return (
      <Badge variant="warning" size={size}>
        Outstanding
      </Badge>
    )
  }
  if (invoice.status === 'paid') {
    return (
      <Badge variant="success" size={size}>
        Paid
      </Badge>
    )
  }
  return (
    <Badge variant="neutral" size={size}>
      {titleCase(invoice.status)}
    </Badge>
  )
}
